const invitationKeys = {
  all: ['invitations']
};

export default invitationKeys;
